import { render, staticRenderFns } from "./salaryLabelList.vue?vue&type=template&id=25fd17d5&scoped=true"
import script from "./salaryLabelList.vue?vue&type=script&lang=js"
export * from "./salaryLabelList.vue?vue&type=script&lang=js"
import style0 from "./salaryLabelList.vue?vue&type=style&index=0&id=25fd17d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd17d5",
  null
  
)

export default component.exports